import Swiper from 'swiper';
import { Navigation, Pagination, Thumbs } from 'swiper/modules';

if (window.location.pathname.indexOf('/details/') > -1) {
    var swiper = new Swiper(".mySwiper", {
        modules: [Navigation, Pagination, Thumbs],
        loop: true,
        spaceBetween: 10,
        slidesPerView: 4,
        slidesPerGroup: 4,
        freeMode: true,
        watchSlidesProgress: true,
        navigation: {
            nextEl: ".sbn",
            prevEl: ".sbp",
        },
    });

    new Swiper(".mySwiper2", {
        modules: [Navigation, Pagination, Thumbs],
        loop: true,
        spaceBetween: 10,
        navigation: {
            nextEl: ".sbn",
            prevEl: ".sbp",
        },
        thumbs: {
            swiper: swiper,
        }
    })
}